import * as React from "react";
import {  Container, Row } from "reactstrap";
import './CenteredContent.scss';

class CenteredContent extends React.Component<any> {
  render() {
    const { className, children } = this.props;
    return (
      <div
        className={
          "d-flex flex-row align-items-center min-vh-100 centered-content " +
          window.brandConfig.theme +
          (className ? ` ${className}` : "")
        }
      >
        <Container>
          <Row>{children}</Row>
        </Container>
        {window.brandConfig.companyLogo && (
          <div id="footer">
            <span id="footer-logo" className="d-inline-block" />
            <span id="footer-text" className="pl-3 align-self-center">
              MARBES CONSULTING s. r. o.
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default CenteredContent;
